import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  mobileProp65Warning: {
    borderTop: '1px solid #E5E5E5',
    marginBottom: '0',
    marginTop: '0',
    padding: '20px 15px 8px',
    '& a': {
      color: '#000000',
    },
    [theme.breakpoints.up('sm')]: {
      border: '1px solid #E5E5E5',
      borderBottom: 'none',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  review: {
    paddingLeft: 0,
    paddingRight: 0,
    // prevent fixed footer from overlapping content
    paddingBottom: 90,
    [theme.breakpoints.up('sm')]: {
      paddingBottom: 30,
    },
    // Handle the quirky way this page has each child component handle its own
    // left/right margins, which no other page allows:
    '& .checkoutNavigationBar': {
      marginLeft: '0',
      marginRight: '0',
    },
  },
  reviewFooter: {
    backgroundColor: '#f5f6f8',
    borderTop: '1px solid #e5e5e5',
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    padding: '20px 15px',
    position: 'fixed',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: theme.palette.background.default,
      border: 'none',
      position: 'static',
    },
  },
  reviewHeading: {
    paddingLeft: '15px',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '0',
    },
  },
}))
